import React from "react";
import { StyledSelectButton } from "./styled-components";
import Text from "../text";
import { ReactComponent as AddIcon } from "../../assets/icons/add.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const SelectButton = ({
  onClick,
  isActive,
  isDisabled,
}: StyledSelectButtonProps) => {
  return (
    <StyledSelectButton onClick={onClick} disabled={isDisabled || false}>
      <Text underline color={isActive ? "grey400" : "blue"} weight={700}>
        {isActive ? "Voir moins" : "Sélectionner"}
      </Text>
      {isActive ? <CloseIcon /> : <AddIcon />}
    </StyledSelectButton>
  );
};

export default SelectButton;
